var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Options"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 9.79086 9.79086 8 12 8H28C30.2091 8 32 9.79086 32 12V28C32 30.2091 30.2091 32 28 32H12C9.79086 32 8 30.2091 8 28V12ZM28 30H12C10.8954 30 10 29.1046 10 28V24.7675C10 24.2734 10.1829 23.7968 10.5134 23.4295L13.2359 20.4045C13.9454 19.6162 15.1467 19.5188 15.974 20.1823L18.2808 22.0327C19.2021 22.7717 20.5598 22.5556 21.2061 21.5671L23.5944 17.9144C24.4392 16.6225 26.3669 16.7338 27.0572 18.1145L29.7889 23.5777C29.9277 23.8554 30 24.1616 30 24.4721V28C30 29.1046 29.1046 30 28 30ZM12.3708 10.3706C12.6098 10.1332 12.9332 10 13.2701 10C13.6071 10 13.9304 10.1332 14.1695 10.3706L19.6653 15.8644C19.7168 15.9176 19.7507 15.9854 19.7624 16.0586L19.9959 17.6002C20.0036 17.6495 20.0005 17.7 19.9868 17.7481C19.9731 17.7962 19.9492 17.8407 19.9167 17.8787C19.8842 17.9167 19.8439 17.9472 19.7985 17.9681C19.7531 17.989 19.7037 17.9999 19.6537 18H19.6005L18.0607 17.7689C17.9875 17.7572 17.9197 17.7233 17.8665 17.6718L12.3708 12.1688C12.1333 11.9298 12 11.6066 12 11.2697C12 10.9328 12.1333 10.6096 12.3708 10.3706Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/Options.fb021b2382515d0fc7a3a8fac4e8ed32.svg";
export { ForwardRef as ReactComponent };